import React, { FC, memo } from "react";
import { ColumnDescriptionDc } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { getFieldTypeLangKey } from "evergis/core/attributes/fieldTypes";
import { Container, Description, Flex, NameContainer } from "../../../EditResource/components/Layer/styled";

export interface AttributeItemProps {
  attribute: ColumnDescriptionDc;
}

export const AttributeItem: FC<AttributeItemProps> = memo(({ attribute }) => {
  const { t } = useTranslation("common");
  const { name, type } = attribute;

  return (
    <Container key={`attr_${name}`}>
      <Flex style={{ alignItems: "center" }}>
        <NameContainer>
          <div>{name}</div>
          <Description>{t(getFieldTypeLangKey(type))}</Description>
        </NameContainer>
      </Flex>
    </Container>
  );
});
